import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useUiTranslation from 'src/hooks/useUiTranslation';

const NotFound = () => {
  const history = useHistory();
  const { tPages } = useUiTranslation();
  return (
    <div className="vh-100 d-flex justify-content-center align-items-md-center flex-column gap-4">
      <h1 className="text-center">
        <FontAwesomeIcon icon={faTriangleExclamation} className="me-2" />
        404
      </h1>
      <div className="text-center">
        <h2>{tPages('pageNotFound.title')}</h2>
        <p>{tPages('pageNotFound.desc')}</p>
      </div>

      <Button variant="primary" onClick={() => history.push('/session-form')}>
        <FontAwesomeIcon icon={faTriangleExclamation} className="me-2" />
        {tPages('pageNotFound.backHome')}
      </Button>
    </div>
  );
};

export default NotFound;
